export default __webpack_public_path__ + "static/media/COPRGTL.210ad1e4.TTF";